import { render, staticRenderFns } from "./SalesAndStockPage.vue?vue&type=template&id=b9e5037c&"
import script from "./SalesAndStockPage.vue?vue&type=script&lang=js&"
export * from "./SalesAndStockPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports